// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* menu-bar should go over monitors, alerts and tutorials */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

/*
If project-title-input.jsx is part of a menu bar say menu-bar.jsx, it can have additional css classes that
can set a width for example or what it should do in a flex box (eg. grow).
*/

.project-title-input_title-field_OUGXx {
    border: 1px dashed var(--ui-black-transparent);
    border-radius: calc(0.5rem / 2);
    -webkit-border-radius: calc(0.5rem / 2);
    -moz-border-radius: calc(0.5rem / 2);
    background-color: var(--project-title-inactive);
    background-clip: padding-box;
    -webkit-background-clip: padding-box;
    height: auto;
    padding: .5rem;
}

.project-title-input_title-field_OUGXx {
    color: var(--menu-bar-foreground);
    font-weight: bold;
    font-size: .8rem;
}

.project-title-input_title-field_OUGXx::-ms-input-placeholder {
    color: var(--menu-bar-foreground);
    opacity: 0.8;
    font-weight: normal;
    font-size: .8rem;
    font-style: italic;
}

.project-title-input_title-field_OUGXx::placeholder {
    color: var(--menu-bar-foreground);
    opacity: 0.8;
    font-weight: normal;
    font-size: .8rem;
    font-style: italic;
}

.project-title-input_title-field_OUGXx:hover {
    background-color: var(--project-title-hover);
    border-color: var(--ui-black-transparent); /* dont use hover border from custom input */
}

.project-title-input_title-field_OUGXx:focus {
    outline:none;
    border: 1px solid var(--ui-transparent);
    box-shadow: 0 0 0 calc(0.5rem * .5) var(--ui-white-transparent-default);
    background-color: var(--ui-white);
    color: var(--text-primary);
}
`, "",{"version":3,"sources":["webpack://./src/components/menu-bar/project-title-input.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,2DAA2D;;AAE3D,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D;;;CAGC;;AAED;IACI,8CAA8C;IAC9C,+BAA+B;IAC/B,uCAAuC;IACvC,oCAAoC;IACpC,+CAA+C;IAC/C,4BAA4B;IAC5B,oCAAoC;IACpC,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,iCAAiC;IACjC,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,4CAA4C;IAC5C,yCAAyC,EAAE,4CAA4C;AAC3F;;AAEA;IACI,YAAY;IACZ,uCAAuC;IACvC,uEAAuE;IACvE,iCAAiC;IACjC,0BAA0B;AAC9B","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* menu-bar should go over monitors, alerts and tutorials */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n/*\nIf project-title-input.jsx is part of a menu bar say menu-bar.jsx, it can have additional css classes that\ncan set a width for example or what it should do in a flex box (eg. grow).\n*/\n\n.title-field {\n    border: 1px dashed var(--ui-black-transparent);\n    border-radius: calc(0.5rem / 2);\n    -webkit-border-radius: calc(0.5rem / 2);\n    -moz-border-radius: calc(0.5rem / 2);\n    background-color: var(--project-title-inactive);\n    background-clip: padding-box;\n    -webkit-background-clip: padding-box;\n    height: auto;\n    padding: .5rem;\n}\n\n.title-field {\n    color: var(--menu-bar-foreground);\n    font-weight: bold;\n    font-size: .8rem;\n}\n\n.title-field::-ms-input-placeholder {\n    color: var(--menu-bar-foreground);\n    opacity: 0.8;\n    font-weight: normal;\n    font-size: .8rem;\n    font-style: italic;\n}\n\n.title-field::placeholder {\n    color: var(--menu-bar-foreground);\n    opacity: 0.8;\n    font-weight: normal;\n    font-size: .8rem;\n    font-style: italic;\n}\n\n.title-field:hover {\n    background-color: var(--project-title-hover);\n    border-color: var(--ui-black-transparent); /* dont use hover border from custom input */\n}\n\n.title-field:focus {\n    outline:none;\n    border: 1px solid var(--ui-transparent);\n    box-shadow: 0 0 0 calc(0.5rem * .5) var(--ui-white-transparent-default);\n    background-color: var(--ui-white);\n    color: var(--text-primary);\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `project-title-input_title-field_OUGXx`;
export { _1 as "title-field" };
export var titleField = `project-title-input_title-field_OUGXx`;
export default ___CSS_LOADER_EXPORT___;
